export default "__VITE_ASSET__Drvg9TBK__"